import GrassIcon from '@mui/icons-material/Grass';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import WorkIcon from '@mui/icons-material/Work';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import type { Business } from 'app-components/flux/business/businessTypes';
import React from 'react';

const taxGroupIcon = {
  NOT_SPECIFIED: WorkIcon,
  PERSONAL: WorkIcon,
  BUSINESS: WorkIcon,
  BUSINESS_S_CORP: WorkIcon,
  PARTNERSHIP: WorkIcon,
  RENTAL_PROPERTY: HomeWorkIcon,
  FARMING: GrassIcon,
  OTHER: WorkIcon,
  UNKNOWN: WorkIcon,
};
export default function BusinessIcon({ business }: { business: Business }) {
  // @ts-expect-error FIXME TS7053
  const Icon = taxGroupIcon[business.taxGroup] || taxGroupIcon.UNKNOWN;
  const theme = useTheme();
  return (
    <Box
      height={40}
      width={40}
      // @ts-expect-error FIXME TS7053
      bgcolor={theme.palette[business.color]?.main || theme.palette.background.layer2}
      borderRadius={40}
      display='flex'
      alignItems='center'
      justifyContent='center'
      mr={2}
    >
      <Icon sx={{ color: theme.palette.background.paper }} />
    </Box>
  );
}
